import React from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const CTA = () => {
  const [ref, isVisible] = useIntersectionObserver();

  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    const target = document.querySelector(targetId);
    if (target) {
      const headerHeight = 100;
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="cta-section">
      <div className="container">
        <div className={`cta-content ${isVisible ? 'scroll-animate in-view' : 'scroll-animate'}`} ref={ref}>
          <h2>
            Pronto para transformar<br />
            seu <span className="gradient-text">negócio</span>?
          </h2>
          <p>Entre em contato conosco e descubra como podemos ajudar sua empresa a alcançar novos patamares com tecnologia de ponta.</p>
          <a href="#contact" className="btn-primary btn-large" onClick={(e) => handleSmoothScroll(e, '#contact')}>Solicite uma Proposta</a>
        </div>
      </div>
    </section>
  );
};

export default CTA;

